
export const DASHBOARD_PATH = `/dashboard`
